import React from 'react';
import withTheme from 'app/ui/config/withTheme';
import '../core/common/style/GradientBackground.css';
import { findKeyInObj } from 'app/utils/objects';
import PropTypes from 'prop-types';
import { hexToCssRgba } from '../../utils/color';

class ThemedGradient extends React.Component {
  render() {
    const colorName = findKeyInObj(this.props.theme, this.props.color);
    const gradientName = findKeyInObj(this.props.theme, this.props.gradient);

    const color = findKeyInObj(this.props.theme.colors, colorName);
    const gradient = findKeyInObj(this.props.theme.colors, gradientName);

    const v1 = hexToCssRgba(gradient, 0.5);
    const v2 = hexToCssRgba(gradient, 0);

    const style = {
      backgroundColor: color,
      backgroundImage: `linear-gradient(-45deg, ${v1}, ${v2})`,
    };

    return this.props.render(style);
  }
}

export default withTheme(ThemedGradient);

ThemedGradient.propTypes = {
  color: PropTypes.string.isRequired,
  gradient: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/app/ui/config/ThemedGradient.js